export default "__VITE_ASSET__Aup7oMik__";